export default {
    body: {
        background: "#FFFFFF",
        text: "#333333",
        headers: "#000000"
    },
    colors: {
        black: "#000",
        white: "#FFF",
        gray: "#F5F5F5",
    },
    queries: {
        mobile: "725px",
        tablet: "900px",
        desktop: "1150px",
    },
    transition: "all cubic-bezier(0.16, 0.8, 0.45, 1) 0.25s",
    typography: {
        font: "'Poppins', sans-serif",
        headerFont: "'Playfair Display', serif",
        fontSize: "20px",
        fontWeight: "400",
        fontLineHeight: "1.6",
        fontLetterSpacing: "1px",
        headerWeight: "700"
    }
}
